export const formatPlaceholders = (text: string): string => {
  return text
    .replace(/{{var:/gm, "@")
    .replace(/{{field:/gm, "@")
    .replace(/{{hidden:/gm, "@")
    .replace(/}}/gm, "");
};
